<template>
  <div class="relative w-full z-50 transition duration-500">
    <nav class="fixed top-0 inset-x-0 max-w-screen-xl mx-auto">
      <div class="fixed justify-start px-4 pt-0.5 lg:pt-2 md:w-auto overflow-none z-50">
        <router-link to="/" class="text-red-600 top-0">
          <!-- Skadi logo -->
          <svg viewBox="0 0 110 100" class="h-12 lg:h-24">
            <circle cx="54" cy="50" r="10" fill="#C4C4C4"/>
            <circle cx="69" cy="76" r="10" fill="#C4C4C4"/>
            <circle cx="39" cy="24" r="10" fill="#C4C4C4"/>
            <circle cx="84" cy="50" r="10" fill="#C4C4C4"/>
            <circle cx="24" cy="50" r="10" fill="#C4C4C4"/>
            <path d="M9 76L99 24" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round"/>
            <path d="M107.66 19L96.8351 30.25L92.505 22.75L107.66 19Z" fill="#C4C4C4"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M80 24C80 29.5228 75.5228 34 70 34C67.3339 34 64.9114 32.9566 63.1187 31.2559C61.8239 30.0275 60.2387 29 58.4539 29H45.7756C43.9887 29 42.3377 29.9536 41.4447 31.5014L37.9832 37.5014C36.0601 40.8347 38.4658 45 42.3141 45H85C86.7716 45 88.4109 45.9375 89.3094 47.4644C90.2078 48.9912 90.2311 50.8796 89.3708 52.4282L74.3708 79.4282C73.4889 81.0155 71.8158 82 70 82H50.4985C48.926 82 47.4937 82.8047 46.2692 83.7913C44.5542 85.173 42.3737 86 40 86C34.4771 86 30 81.5229 30 76C30 70.4772 34.4771 66 40 66C42.9298 66 45.5654 67.26 47.3944 69.2677C48.7328 70.7368 50.4524 72 52.4397 72H64.116C65.9318 72 67.6049 71.0155 68.4867 69.4282L72.3756 62.4282C74.2271 59.0956 71.8173 55 68.0049 55H25C23.214 55 21.5635 54.0473 20.6703 52.5007C19.777 50.9541 19.7765 49.0484 20.6691 47.5014L35.6691 21.5014C36.562 19.9536 38.2131 19 40 19H58.4539C60.2387 19 61.8239 17.9725 63.1187 16.7441C64.9114 15.0434 67.3339 14 70 14C75.5228 14 80 18.4772 80 24ZM45 76C45 78.7614 42.7614 81 40 81C37.2386 81 35 78.7614 35 76C35 73.2386 37.2386 71 40 71C42.7614 71 45 73.2386 45 76ZM70 29C72.7614 29 75 26.7614 75 24C75 21.2386 72.7614 19 70 19C67.2386 19 65 21.2386 65 24C65 26.7614 67.2386 29 70 29Z" fill="currentColor" />
          </svg>
        </router-link>
      </div>
      <div class="flex items-end pl-20 lg:pl-32 pt-2 lg:pt-6 font-medium text-gray-500 shadow-md lg:shadow-none transition ease-in-out duration-300 z-30" :class="{ 'bg-white opacity-97': scrolled }">
        <router-link to="/features" class="px-4 py-2 border-b-4 hover:border-red-600 hover:text-gray-900 focus:outline-none focus:text-gray-900 transition duration-100 ease-in-out" :class="{ 'border-transparent': $route.path !== '/features' }">Features</router-link>
        <router-link to="/pricing" class="ml-4 mr-4 md:ml-6 md:mr-6 px-4 py-2 border-b-4 hover:border-red-600 hover:text-gray-900 focus:outline-none focus:text-gray-900 transition duration-100 ease-in-out" :class="{ 'border-transparent': $route.path !== '/pricing' }">Pricing</router-link>
      </div>
      <div class="flex items-center hidden">
        <button @click="menuOpen = !menuOpen" type="button" class="mr-6 sm:mr-4 inline-flex items-center justify-center rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out">
          <svg class="h-8 w-8" stroke="currentColor" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
<!--
      <div class="hidden md:block text-right">
        <span class="inline-flex rounded-md shadow-md">
          <span class="inline-flex rounded-md shadow-xs">
            <router-link to="#" class="inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-red-600 bg-white hover:bg-gray-50 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out">
              Log in
            </a>
          </span>
        </span>
      </div>
-->
    </nav>

    <transition
      enter-active-class="duration-200 ease-out"
      enter-class="opacity-0 -translate-y-full"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="duration-200 ease-in"
      leave-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-full"
    >
      <div v-if="menuOpen" class="absolute top-0 inset-x-0 py-2 px-2 transition transform origin-top md:hidden">
        <div class="rounded-lg shadow-md">
          <div class="rounded-lg bg-white shadow-xs overflow-hidden">
            <div class="px-5 pt-4 flex items-center justify-between">
              <div class="text-red-600">
                <svg viewBox="0 0 120 120" class="h-24">
                  <circle cx="59" cy="60" r="10" fill="#C4C4C4"/>
                  <circle cx="74" cy="86" r="10" fill="#C4C4C4"/>
                  <circle cx="44" cy="34" r="10" fill="#C4C4C4"/>
                  <circle cx="89" cy="60" r="10" fill="#C4C4C4"/>
                  <circle cx="29" cy="60" r="10" fill="#C4C4C4"/>
                  <path d="M14 86L104 34" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round"/>
                  <path d="M112.66 29L101.835 40.25L97.505 32.75L112.66 29Z" fill="#C4C4C4"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M85 34C85 39.5228 80.5228 44 75 44C72.3339 44 69.9114 42.9566 68.1187 41.2559C66.8239 40.0275 65.2387 39 63.4539 39H50.7756C48.9887 39 47.3377 39.9536 46.4447 41.5014L42.9832 47.5014C41.0601 50.8347 43.4658 55 47.3141 55H90C91.7716 55 93.4109 55.9375 94.3094 57.4644C95.2078 58.9912 95.2311 60.8796 94.3708 62.4282L79.3708 89.4282C78.4889 91.0155 76.8158 92 75 92H55.4985C53.926 92 52.4937 92.8047 51.2692 93.7913C49.5542 95.173 47.3737 96 45 96C39.4771 96 35 91.5229 35 86C35 80.4772 39.4771 76 45 76C47.9298 76 50.5654 77.26 52.3944 79.2677C53.7328 80.7368 55.4524 82 57.4397 82H69.116C70.9318 82 72.6049 81.0155 73.4867 79.4282L77.3756 72.4282C79.2271 69.0956 76.8173 65 73.0049 65H30C28.214 65 26.5635 64.0473 25.6703 62.5007C24.777 60.9541 24.7765 59.0484 25.6691 57.5014L40.6691 31.5014C41.562 29.9536 43.2131 29 45 29H63.4539C65.2387 29 66.8239 27.9725 68.1187 26.7441C69.9114 25.0434 72.3339 24 75 24C80.5228 24 85 28.4772 85 34ZM50 86C50 88.7614 47.7614 91 45 91C42.2386 91 40 88.7614 40 86C40 83.2386 42.2386 81 45 81C47.7614 81 50 83.2386 50 86ZM75 39C77.7614 39 80 36.7614 80 34C80 31.2386 77.7614 29 75 29C72.2386 29 70 31.2386 70 34C70 36.7614 72.2386 39 75 39Z" fill="currentColor"/>
                </svg>
              </div>
              <div class="-mr-1 -mt-6">
                <button @click="menuOpen = false" type="button" class="inline-flex items-center justify-center px-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out">
                  <svg class="h-8 w-8" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            <div class="px-2 pt-2 pb-3" @click="menuOpen = false">
              <router-link to="/features" class="block px-6 py-4 rounded-md text-xl font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out">Features</router-link>
              <router-link to="/" class="mt-1 block px-6 py-4 rounded-md text-xl font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out">Pricing</router-link>
            </div>
<!--
            <div>
              <router-link to="#" class="block w-full px-5 py-3 text-center font-medium text-red-600 bg-gray-50 hover:bg-gray-100 hover:text-red-700 focus:outline-none focus:bg-gray-100 focus:text-red-700 transition duration-150 ease-in-out">
                Log in
              </a>
            </div>
-->
          </div>
        </div>
      </div>
    </transition>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        menuOpen: false,
        scrollAt: 40,
        scrolled: false
      }
    },
    mounted() {
      window.onscroll = () => {
        this.scrolled = (document.body.scrollTop > this.scrollAt || document.documentElement.scrollTop > this.scrollAt);
      }
    }
  }
</script>
